/* ═══════════════════════════════════════
   DUMONI JEWELERS — Theme JS
═══════════════════════════════════════ */

(function() {

  /* ── STICKY INQUIRY BUTTON ── */
  var sticky = document.getElementById('sticky-inquiry');
  if (sticky) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 300) {
        sticky.classList.add('visible');
      } else {
        sticky.classList.remove('visible');
      }
    }, { passive: true });
  }

  /* ── SCROLL REVEAL ── */
  var reveals = document.querySelectorAll('.reveal');
  if (reveals.length) {
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.07, rootMargin: '0px 0px -20px 0px' });
    reveals.forEach(function(el) { obs.observe(el); });
  }

  /* ── PHOTO SHOWCASE REVEAL ── */
  var showcases = document.querySelectorAll('[data-showcase]');
  if (showcases.length) {
    var showObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          showObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.06 });
    showcases.forEach(function(el) { showObs.observe(el); });
  }

  /* ── HEADER HIDE ON SCROLL DOWN ── */
  var header = document.getElementById('site-header');
  if (header) {
    var lastY = 0;
    window.addEventListener('scroll', function() {
      var y = window.scrollY;
      header.classList.toggle('hidden', y > 100 && y > lastY);
      lastY = y;
    }, { passive: true });
  }

  /* ── ANNOUNCEMENT BAR DUPLICATE FOR INFINITE SCROLL ── */
  var track = document.querySelector('.announcement__track');
  if (track) {
    track.innerHTML += track.innerHTML;
  }

  /* ── LAZY VIDEO AUTOPLAY ── */
  var videos = document.querySelectorAll('video[autoplay]');
  if (videos.length) {
    var vidObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.play();
        } else {
          entry.target.pause();
        }
      });
    }, { threshold: 0.2 });
    videos.forEach(function(v) { vidObs.observe(v); });
  }

})();